import { render, staticRenderFns } from "./settlement-inquiry.vue?vue&type=template&id=04dba727&scoped=true&"
import script from "./settlement-inquiry.vue?vue&type=script&lang=js&"
export * from "./settlement-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./settlement-inquiry.vue?vue&type=style&index=0&id=04dba727&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dba727",
  null
  
)

export default component.exports